export const HERO = {
  init: function heroSlide() {
    const curtain = document.querySelector('.p-top-hero__img')

    if (curtain) {
      setTimeout(() => {
        curtain.classList.add('animate')
      }, 300) // 0.5秒後にアニメーション開始
    }
  },
}
